import type { Common, MstCommon } from '@libs/domain';
import { SingleDate, dateToStr, strToDate } from '@ps-smart-cp/ppfw-client';

export class MstRegistration
  implements
    Pick<Common['schema'], 'id' | 'version'>,
    Pick<
      MstCommon['schema'],
      | 'code'
      | 'mstNote'
      | 'mstSpareName01'
      | 'mstSpareName02'
      | 'name'
      | 'validityEndDate'
      | 'validityStartDate'
    >
{
  /**
   * マスタ登録_共通model
   *
   * @param code コード
   * @param name 名称
   * @param mstSpareName01 予備名称1
   * @param mstSpareName02 予備名称2
   * @param validityStartDate 有効開始年月日
   * @param validityEndDate 有効終了年月日
   * @param mstNote マスタ備考
   */

  protected constructor(
    readonly id: number,
    readonly version: number,
    readonly code: string,
    readonly name: string,
    readonly mstSpareName01: string,
    readonly mstSpareName02: string,
    readonly validityStartDate: Date | null,
    readonly validityEndDate: Date | null,
    readonly mstNote: string,
  ) {}

  static baseInit(code?: string) {
    return new MstRegistration(-1, -1, code ?? '', '', '', '', SingleDate.MIN_DATE, SingleDate.MAX_DATE, '');
  }

  static baseFromRaw(raw: MstRegistrationRaw) {
    return new MstRegistration(
      raw.id,
      raw.version,
      raw.code,
      raw.name,
      raw.mstSpareName01,
      raw.mstSpareName02,
      strToDate(raw.validityStartDate),
      strToDate(raw.validityEndDate),
      raw.mstNote,
    );
  }
}

export class MstRegistrationRaw
  implements
    Pick<Common['record'], 'id' | 'version'>,
    Pick<
      MstCommon['record'],
      | 'code'
      | 'mstNote'
      | 'mstSpareName01'
      | 'mstSpareName02'
      | 'name'
      | 'validityEndDate'
      | 'validityStartDate'
    >
{
  protected constructor(
    readonly id: number,
    readonly version: number,
    readonly code: string,
    readonly name: string,
    readonly mstSpareName01: string,
    readonly mstSpareName02: string,
    readonly validityStartDate: string,
    readonly validityEndDate: string,
    readonly mstNote: string,
  ) {}

  static baseFromModel(mstRegistration: MstRegistration): MstRegistrationRaw {
    return new MstRegistrationRaw(
      mstRegistration.id,
      mstRegistration.version,
      mstRegistration.code,
      mstRegistration.name,
      mstRegistration.mstSpareName01,
      mstRegistration.mstSpareName02,
      dateToStr(mstRegistration.validityStartDate, 'yyyyMMdd'),
      dateToStr(mstRegistration.validityEndDate, 'yyyyMMdd'),
      mstRegistration.mstNote,
    );
  }
}
